import React from "react";
import BrandDetail from "./BrandDetail";

const SubsZone = () => {
	return <BrandDetail brandKey="subs-zone" />;
};

export default SubsZone;
